/* eslint-disable max-lines */
import React, { useMemo } from 'react';
import { Switch } from 'react-router-dom';

// Utils
import Route from './utils/Route';
import { useAuth } from './hooks/useAuth';

// First Touch
import App from './App';
import HomePage from './components/HomePage';
import LoginPage from './components/LoginPage';
import LoginSSOPage from './components/LoginSSOPage';
import SignUpPage from './components/SignUpPage';
import ForgotPasswordPage from './components/ForgotPasswordPage';
import ChangePassword from './components/ChangePasswordPage';
import LogoutPage from './components/LogoutPage';

// Advanced Search
import AdvancedSearchLoginPage from './components/AdvancedSearchLoginPage';
import AdvancedSearchHome from './components/AdvancedSearchHome';
import GradeReviewPage from './components/GradeReview';
import InvestigationDetailsReviewPage from './components/InvestigationDetailsReviewPage';
import GradeDataReviewListPage from './components/GradeDataReviewPage';
import AdvancedSearchUploadCSVPage from './components/AdvancedSearchUploadCSVPage';

// General Routes
import TagDetailsPage from './components/TagDetailsPage';
import ManageTagsPage from './components/ManageTagsPage';
import NotificationList from './components/NotificationList';
import MessageListPage from './components/MessageListPage';

// Teacher Routes
import TeacherUsers from './components/TeacherUsers';
import ManageTeacherTransferPage from './components/ManageTeacherTransferPage';
import TeacherInsights from './components/TeacherInsights';
import InvestigationTypePage from './components/InvestigationTypePage';
import InvestigationWalkthroughPage from './components/InvestigationWalkthroughPage';
import InvestigationSettingsPage from './components/InvestigationSettingsPage';
import AssignInvestigationPage from './components/AssignInvestigationPage';
import InvestigationDetailsPage from './components/InvestigationDetailsPage';
import InvestigationLibraryPage from './components/InvestigationLibraryPage';
import TeacherDashboard from './components/TeacherDashboard';
import GoogleClassroomTeachersDashboardPage from './components/GoogleClassroomTeachersDashboardPage';
// Investigation
import InvestigationSettings from './components/InvestigationSettings';
import InvestigationSummary from './components/InvestigationSummary';
import AssessmentGradingPage from './components/AssessmentGradingPage';
import InvestigationGradingPage from './components/InvestigationGradingPage';
import InvestigationTeacherDetailsPage from './components/InvestigationTeacherDetailsPage';
import InvestigationPresentationPage from './components/InvestigationPresentationPage';
import InvestigationGradeReportPage from './components/InvestigationGradeReportPage';
import InvestigationFilePreview from './components/StudentInvestigation/InvestigationFilePreview';

// Class
import ClassDashboard from './components/ClassDashboard';
import GoogleClassDashboard from './components/GoogleClassDashboard';
// Student Routes
import StudentsDetails from './components/StudentsDetails';
import StudentInvestigationDetails from './components/StudentInvestigationDetails';
import StudentClassDetail from './components/StudentClassDetail';
import StudentDueDates from './components/StudentDueDates';
import StudentDashboard from './components/StudentDashboard';
import StudentInvestigation from './components/StudentInvestigation';

// Peer Review
import PeerReviewInvestigationPage from './components/PeerReviewInvestigationPage';
import PeerReviewReportInvestigationPage from './components/PeerReviewReportInvestigationPage';

// Comments Routes
import CommentsInvestigationPage from './components/CommentsInvestigationPage';
import BestCommentsInvestigationPage from './components/BestCommentsInvestigationPage';

// ADI Admin Routes
import AdiDashboardPage from './components/AdiDashboardPage';
import OrganizationSyncList from './components/OrganizationSyncList';
import SyncList from './components/SyncList';
import SyncDetailsPage from './components/SyncDetails';
import UserList from './components/UserList';
import WalkthroughListPage from './components/WalkthroughListPage';
import WalkthroughDetailsPage from './components/WalkthroughDetailsPage';
import UserDetailsPage from './components/UserDetailsPage';
import OrganizationDetailsPage from './components/OrganizationDetailsPage';
import OrganizationList from './components/OrganizationList';
import AdiAssessmentPage from './components/AdiAssessmentPage';
import AdiAssessmentTemplatesPage from './components/AdiAssessmentTemplatePage';
import AdiAssessmentListPage from './components/AdiAssessmentListPage';
import AdiTemplatesPage from './components/AdiTemplatesPage';
import AdiInvestigationListPage from './components/AdiInvestigationListPage';
import AdiEditInvestigationCorePage from './components/AdiEditInvestigationCorePage';
import AdiEditInvestigationPreviewPage from './components/AdiEditInvestigationPreviewPage';
import AdiEditInvestigationActivitiesPage from './components/AdiEditInvestigationActivitiesPage';
import AdiEditInvestigationStagesPage from './components/AdiEditInvestigationStagesPage';
import AdiInvestigationsPage from './components/AdiInvestigationsPage';

// Others
import ConceptEvaluationInvestigationPage from './components/ConceptEvaluationInvestigationPage';
import BestConceptPeerReviewInvestigationPage from './components/BestConceptPeerReviewInvestigationPage';
import ReflectReportInvestigationPage from './components/ReflectReportInvestigationPage';
import TeacherProfilePage from './components/TeacherProfilePage';
import StudentProfilePage from './components/StudentProfilePage';
import GenericProfilePage from './components/GenericProfilePage';
import PrivacyPolicyPage from './components/PrivacyPolicyPage/PrivacyPolicyPage';
import TermsOfServicePage from './components/TermsOfServicePage/TermsOfServicePage';
import AssessmentTypePage from './components/AssessmentTypePage';
import LearnMore from './components/Books/LandingPage/LearnmoreAbout';

import AssessmentLibraryPage from './components/AssessmentLibraryPage';
import AssessmentSummaryDashboard from './components/AssessmentSummaryDashboard';
import AssessmentResultsSummary from './components/AssessmentSummaryDashboard/AssessmentResultsSummary';
import AssessmentGradeReportPage from './components/AssessmentGradeReportPage';

// Checkout
import CreatePaymentIntentPage from './components/Checkout/PaymentIntent';
import SubscriptionPackageSelectionPage from './components/SubscriptionPackageSelectionPage';
import BillingInformationPage from './components/BillingInformation';
import SubscriptionPackageSelectionPublicPage from './components/SubscriptionPackageSelectionPage/SubscriptionPackageSelectionPublicPage';
import WhitelistDomainPage from './components/WhitelistDomainPage';

//google
import GoogleAssignmentCorePage from './components/GoogleAssignmentCorePage';
import GoogleAssignmentSummaryDasboard from './components/GoogleAssignmentSummaryDasboard';
import GoogleClassroomTeacherAssignmentPage from './components/GoogleClassroomTeacherAssignmentPage'
// import GoogleTeachersAssignmentDashboard from './components/GoogleTeachersAssignmentDashboard';
import GoogleTeacherAssignmentSummary from './components/GoogleTeacherAssignmentSummary';
//googlestudents 
import GoogleClassroomStudentsDashboardPage from './components/GoogleClassroomStudentsDashboardPage';
import GoogleStudentsClassDashboard from './components/GoogleStudentsClassDashboard';
import AssignmentSummaryPopup from './components/GoogleClassroomStudentsDashboardPage/GActiveAssignmentsRow/AssignmentSummaryPopup';
import GoogleStudentsAssignmentDueDate from './components/GoogleStudentsAssignmentDueDate';

//canvas
import CanvasTeachersDashboard from './components/CanvasTeachersDashboard';
import CanvasTeachersClassDashboard from './components/CanvasTeachersClassDashboard';
import CanvasStudentsDashboardPage from './components/CanvasStudentsDashboardPage';
import CanvasAssignmentCorePage from './components/CanvasAssignmentCorePage';
import CanvasStudentsClassDashboard from './components/CanvasStudentsClassDashboard';
import CanvasTeacherAssignmentPage from './components/CanvasTeacherAssignmentPage';
import CanvasTeacherAssignmentSummary from './components/CanvasTeacherAssignmentSummary';
import CanvasStudentsAssignmentDuedate from './components/CanvasStudentsAssignmentDuedate'
import BookSignUp from './components/Books/BookSignUp';
import BookCode from './components/Books/BookCode';
import BookLogin from './components/Books/BookLogin';
import BookDetails from './components/Books/BookDetails';
import Library from './components/Books/Library';
import OrderListPage from './components/Books/OrderListPage';
import OrderDetails from './components/Books/OrderDetails';
import QuoteListPage from './components/Books/QuoteListPage';
import BookUserProfile from './components/Books/BookUserProfile';
import OrgSignUp from './components/Books/OrgSignUp';
import BookPage from './components/Books/BookPage';

import BookInvestigationPage from './components/Books/BookInvestigationPage';
import BookWishlistPage from './components/Books/BookWishlistPage';
// import LandingPage from './components/Books/LandingPage';
import BookAdmin from './components/Books/BookAdmin';
import BookEdit from './components/Books/BookAdmin/BookEdit';
//import LandingPage from './components/Books/LandingPage';
import Videolib from './components/Books/LandingPage/Videolib';
import Profile from './components/Books/LandingPage/Profile';
import LoginNew from './components/Books/Login_new';
// import LoginNewacc from './components/Books/Login_new/Account';
import TeacherAccountPage from './components/Books/Login_new/Account';
import CartPage from './components/Books/Cart';
import AdiSuperAdminDashboard from './components/AdiSuperAdminDashboard';
// import InvestigationPresentationPageWrapper from './components/InvestigationPresentationPage/InvestigationPresentationPageWrapper';
//import AllAccount from './components/AdiSuperAdminDashboard/AllAccounts';
import AdiInvestigationListPageV2 from './components/AdiInvestigationListPageV2';
import InvestigationTeacherLibraryPageV2 from './components/InvestigationTeacherLibraryPage';

export default () => {
  const { isTeacherOrFacilitator, isStudent } = useAuth();
  const ProfileComponent = useMemo(() => {
    if (isTeacherOrFacilitator) return TeacherProfilePage;
    if (isStudent) return StudentProfilePage;
    return GenericProfilePage;
  }, [isTeacherOrFacilitator, isStudent]);

  return (
    <App>
      <Switch>
        {/* First Touch */}
        {/* <Route path="/super-admin-dashboard" component={AdiSuperAdminDashboard} routeTypes={['onlyUnauthenticatedRoute']} exact /> */}
        <Route path="/home" component={HomePage} routeTypes={['onlyUnauthenticatedRoute']} exact />
        <Route path="/testing" component={AdiInvestigationListPageV2} routeTypes={['authenticatedRoute']} />
        <Route path="/login" component={LoginPage} routeTypes={['onlyUnauthenticatedRoute']} />

        <Route path="/account-type" component={TeacherAccountPage} routeTypes={['onlyUnauthenticatedRoute']} />

        {/* TODO: Change later as per requirement  */}
        <Route path="/learnmore" component={LearnMore} routeTypes={['onlyUnauthenticatedRoute']} />
        <Route path="/bookSignup" component={BookSignUp} routeTypes={['onlyUnauthenticatedRoute']} />
        <Route path="/bookCode" component={BookCode} routeTypes={['bookModuleRoute']} />
        <Route path="/bookDetails/:bookCode" component={BookDetails} routeTypes={['bookModuleRoute']} />
        <Route path="/bookLogin" component={BookLogin} routeTypes={['onlyUnauthenticatedRoute']} />
        <Route path="/booklib" component={Library} routeTypes={['bookModuleRoute']} />
        <Route path="/bookPage/:bookId" component={BookPage} routeTypes={['bookModuleRoute']} />
        <Route path="/videolib" component={Videolib} routeTypes={['onlyUnauthenticatedRoute']} />
        <Route path="/founder" component={Profile} routeTypes={['onlyUnauthenticatedRoute']} />
        <Route path="/bookinvestigation/:bookId" component={BookInvestigationPage} routeTypes={['bookModuleRoute']} />
        <Route path="/bookprofile" component={BookUserProfile} routeTypes={['bookModuleRoute']} />
        <Route path="/bookWishList" component={BookWishlistPage} routeTypes={['bookModuleRoute']} />
        <Route path="/bookorderlist" component={OrderListPage} routeTypes={['bookModuleRoute']} />
        <Route path="/bookorderdetail/:id" component={OrderDetails} routeTypes={['bookModuleRoute']} />
        <Route path="/bookquoteList" component={QuoteListPage} routeTypes={['bookModuleRoute']} />
        <Route path="/orgSignup" component={OrgSignUp} routeTypes={['onlyUnauthenticatedRoute']} />
        <Route path="/cart" component={CartPage} routeTypes={['bookModuleRoute']} />

        {/*  TODO: testing route below remove after use  */}

        <Route path="/bookadmin" component={BookAdmin} routeTypes={['authenticatedRoute']} />
        <Route path="/bookedit/:bookId" component={BookEdit} routeTypes={['authenticatedRoute']} />
        {/*   End here   */}

        <Route path="/sso" component={LoginSSOPage} routeTypes={['onlyUnauthenticatedRoute']} />
        <Route path="/session-expired" component={LogoutPage} routeTypes={['authenticatedRoute']} />
        <Route path="/register/:token" component={SignUpPage} routeTypes={['onlyUnauthenticatedRoute']} />
        <Route path="/forgot-password" component={ForgotPasswordPage} routeTypes={['onlyUnauthenticatedRoute']} />
        <Route path="/change-password/:token" component={ChangePassword} routeTypes={['onlyUnauthenticatedRoute']} />
        <Route path="/privacy-policy" component={PrivacyPolicyPage} routeTypes={['onlyUnauthenticatedRoute']} />
        <Route path="/terms-and-conditions" component={TermsOfServicePage} routeTypes={['onlyUnauthenticatedRoute']} />
        <Route
          path="/pricing"
          component={SubscriptionPackageSelectionPublicPage}
          routeTypes={['onlyUnauthenticatedRoute']}
          exact
        />


        {/* Advanced Search Routes */}
        <Route
          path="/advanced-search/:version/login"
          component={AdvancedSearchLoginPage}
          routeTypes={['onlyUnauthenticatedRoute']}
        />
        <Route
          path="/advanced-search/:version/home"
          component={AdvancedSearchHome}
          routeTypes={['advancedSearchRoute']}
          exact
        />
        <Route
          path="/advanced-search/:grade/contentType/:type/:investigationId"
          component={InvestigationDetailsReviewPage}
          routeTypes={['advancedSearchRoute']}
        />
        <Route
          path="/advanced-search/:version/:grade/grade"
          component={GradeReviewPage}
          routeTypes={['advancedSearchRoute']}
        />
        <Route
          path="/advanced-search/:version/:grade/contentType/:type"
          component={GradeDataReviewListPage}
          routeTypes={['advancedSearchRoute']}
        />
        <Route path="/upload-csv" component={AdvancedSearchUploadCSVPage} exact routeTypes={['adiRoute']} />
        <Route path="/whitelist-domain" component={WhitelistDomainPage} exact routeTypes={['adiRoute']} />

        {/* General Routes */}
        <Route path="/manage-tags/:tagId" component={TagDetailsPage} routeTypes={['authenticatedRoute']} />
        <Route path="/manage-tags" component={ManageTagsPage} routeTypes={['authenticatedRoute']} />
        <Route path="/profile" component={ProfileComponent} routeTypes={['authenticatedRoute']} />
        <Route path="/notifications" component={NotificationList} routeTypes={['authenticatedRoute']} />
        <Route path="/messages" component={MessageListPage} routeTypes={['authenticatedRoute']} />
        <Route path="/transfer-teacher/:token" component={ManageTeacherTransferPage} routeTypes={[]} />

        <Route
          path="/checkout-confirmation/:priceId"
          component={CreatePaymentIntentPage}
          routeTypes={['authenticatedRoute', 'allowDisabled']}
        />

        <Route
          path="/billing-information"
          component={BillingInformationPage}
          routeTypes={['authenticatedRoute', 'allowDisabled']}
        />

        {/* Teacher Routes */}
        <Route path="/teacher-users" component={TeacherUsers} routeTypes={['teacherRoute', 'canvasTeacherRoute', 'googleTeacherRoute']} exact />
        <Route path="/teacher-insights/:type" component={TeacherInsights} routeTypes={['teacherRoute', 'canvasTeacherRoute', 'googleTeacherRoute']} />
        <Route path="/teacher-investigation" component={InvestigationTypePage} routeTypes={['teacherRoute', 'canvasTeacherRoute', 'googleTeacherRoute']} exact />
        <Route
          path="/teacher-investigation/:type/:investigationId/preview"
          component={InvestigationWalkthroughPage}
          routeTypes={['teacherRoute', 'canvasTeacherRoute', 'googleTeacherRoute']}
        />
        <Route
          path="/teacher-investigation/:type/:investigationId/settings"
          component={InvestigationSettingsPage}
          routeTypes={['teacherRoute', 'canvasTeacherRoute', 'googleTeacherRoute']}
        />
        <Route
          path="/teacher-investigation/:type/:investigationId/assign"
          component={AssignInvestigationPage}
          routeTypes={['teacherRoute', 'canvasTeacherRoute', 'googleTeacherRoute']}
        />
        <Route
          path="/teacher-investigation/:type/:investigationId"
          component={InvestigationDetailsPage}
          routeTypes={['teacherRoute', 'canvasTeacherRoute', 'googleTeacherRoute']}
        />
        <Route exact path="/test/teacher-investigation/:type" component={InvestigationTeacherLibraryPageV2} routeTypes={['teacherRoute', 'canvasTeacherRoute', 'googleTeacherRoute']} />

        <Route path="/teacher-investigation/:type" component={InvestigationLibraryPage} routeTypes={['teacherRoute', 'canvasTeacherRoute', 'googleTeacherRoute']} />

        <Route path="/teacher-assessment" component={AssessmentTypePage} routeTypes={['teacherRoute', 'canvasTeacherRoute', 'googleTeacherRoute']} exact />

        <Route path="/teacher-assessment/:type" component={AssessmentLibraryPage} routeTypes={['teacherRoute', 'canvasTeacherRoute', 'googleTeacherRoute']} />

        <Route
          path="/teacher-dashboard"
          component={TeacherDashboard}
          routeTypes={['teacherRoute', 'teacherAssistantRoute', 'canvasTeacherRoute', 'googleTeacherRoute']}
          exact
        />
        <Route
          path="/teacher-dashboard/class/:classId/student/:studentId/summary"
          component={StudentInvestigationDetails}
          routeTypes={['teacherRoute', 'teacherAssistantRoute', 'canvasTeacherRoute', 'googleTeacherRoute']}
          strict
        />
        <Route
          path="/teacher-dashboard/class/:classId/student/:studentId"
          component={StudentsDetails}
          routeTypes={['teacherRoute', 'teacherAssistantRoute', 'canvasTeacherRoute', 'googleTeacherRoute']}
        />
        <Route
          path="/teacher-dashboard/investigation-summary/:investigationId/settings"
          component={InvestigationSettings}
          routeTypes={['teacherRoute', 'googleTeacherRoute', 'canvasTeacherRoute']}
        />
        <Route
          path="/teacher-dashboard/investigation-summary/:investigationId"
          component={InvestigationSummary}
          routeTypes={['teacherRoute', 'teacherAssistantRoute', 'googleTeacherRoute', 'canvasTeacherRoute']}
        />
        <Route
          path="/teacher-dashboard/assessment-summary/:assessmentId/results"
          component={AssessmentResultsSummary}
          routeTypes={['teacherRoute', 'teacherAssistantRoute', 'canvasTeacherRoute', 'googleTeacherRoute']}
          exact
        />
        <Route
          path="/teacher-dashboard/assessment-summary/:assessmentId/:submissionVersion?"
          component={AssessmentSummaryDashboard}
          routeTypes={['teacherRoute', 'teacherAssistantRoute', 'canvasTeacherRoute', 'googleTeacherRoute']}
          exact
        />
        <Route
          path="/teacher-dashboard/assessment-presentation/:investigationId"
          component={InvestigationPresentationPage}
          routeTypes={['teacherRoute', 'canvasTeacherRoute', 'googleTeacherRoute']}
        />
        <Route
          path="/teacher-dashboard/assessment-details/:investigationId/grade/:studentId/:submissionVersion?"
          component={AssessmentGradingPage}
          routeTypes={['teacherRoute', 'teacherAssistantRoute', 'canvasTeacherRoute', 'googleTeacherRoute']}
        />
        <Route
          path="/teacher-dashboard/investigation-details/:investigationId/grade/:studentId"
          component={InvestigationGradingPage}
          routeTypes={['teacherRoute', 'teacherAssistantRoute', 'canvasTeacherRoute', 'googleTeacherRoute']}
        />
        <Route
          path="/teacher-dashboard/investigation-details/:investigationId/students/:studentId/:submissionVersion?"
          component={InvestigationTeacherDetailsPage}
          routeTypes={['teacherRoute', 'teacherAssistantRoute', 'canvasTeacherRoute', 'googleTeacherRoute']}
        />
        <Route
          path="/teacher-dashboard/investigation-details/:investigationId/:studentId/:submissionVersion?"
          component={InvestigationTeacherDetailsPage}
          routeTypes={['teacherRoute', 'teacherAssistantRoute', 'canvasTeacherRoute', 'googleTeacherRoute']}
        />
        <Route
          path="/teacher-dashboard/investigation-details/:investigationId/:submissionVersion?"
          component={InvestigationTeacherDetailsPage}
          routeTypes={['teacherRoute', 'teacherAssistantRoute', 'canvasTeacherRoute', 'googleTeacherRoute']}
        />
        <Route
          path="/teacher-dashboard/assessment-details/:investigationId/:submissionVersion?"
          component={InvestigationTeacherDetailsPage}
          routeTypes={['teacherRoute', 'teacherAssistantRoute', 'canvasTeacherRoute', 'googleTeacherRoute']}
        />
        <Route
          path="/teacher-dashboard/investigation-presentation/:investigationId"
          component={InvestigationPresentationPage}
          routeTypes={['teacherRoute', 'teacherAssistantRoute', 'canvasTeacherRoute', 'googleTeacherRoute']}
        />
        <Route path="/teacher-dashboard/student/:studentId" component={StudentsDetails} routeTypes={['teacherRoute']} />
        <Route
          path="/teacher-dashboard/class/:classId/assign-investigation/:type/:investigationId/preview"
          component={InvestigationWalkthroughPage}
          routeTypes={['teacherRoute', 'canvasTeacherRoute', 'googleTeacherRoute']}
        />
        <Route
          path="/teacher-dashboard/class/:classId/assign-investigation/:type/:investigationId/settings"
          component={InvestigationSettingsPage}
          routeTypes={['teacherRoute', 'canvasTeacherRoute', 'googleTeacherRoute']}
        />
        <Route
          path="/teacher-dashboard/class/:classId/assign-investigation/:type/:investigationId/assign"
          component={AssignInvestigationPage}
          routeTypes={['teacherRoute', 'canvasTeacherRoute', 'googleTeacherRoute']}
        />
        <Route
          path="/teacher-dashboard/class/:classId/assign-investigation/:type/:investigationId"
          component={InvestigationDetailsPage}
          routeTypes={['teacherRoute']}
        />
        <Route
          path="/teacher-dashboard/class/:classId/assign-investigation/:type"
          component={InvestigationLibraryPage}
          routeTypes={['teacherRoute', 'canvasTeacherRoute', 'googleTeacherRoute']}
        />
        <Route
          path="/teacher-dashboard/class/:classId/assign-investigation"
          component={InvestigationTypePage}
          routeTypes={['teacherRoute', 'canvasTeacherRoute', 'googleTeacherRoute']}
          strict
        />
        <Route
          path="/teacher-dashboard/class/:classId/assign-assessment/:type/:investigationId/assign"
          component={AssignInvestigationPage}
          routeTypes={['teacherRoute', 'canvasTeacherRoute', 'googleTeacherRoute']}
        />
        <Route
          path="/teacher-dashboard/class/:classId/assign-assessment/:type"
          component={InvestigationLibraryPage}
          routeTypes={['teacherRoute', 'canvasTeacherRoute', 'googleTeacherRoute']}
        />
        <Route
          path="/teacher-dashboard/class/:classId/assign-assessment"
          component={InvestigationTypePage}
          routeTypes={['teacherRoute', 'canvasTeacherRoute', 'googleTeacherRoute']}
          strict
        />
        <Route
          path="/teacher-dashboard/class/:id"
          component={ClassDashboard}
          routeTypes={['teacherRoute', 'teacherAssistantRoute', 'canvasTeacherRoute', 'googleTeacherRoute']}
        />
        <Route
          path="/manage-subscription"
          component={SubscriptionPackageSelectionPage}
          routeTypes={['teacherRoute', 'allowDisabled']}
        />

        {/* Student Routes */}
        <Route path="/student-dashboard/class/:id" component={StudentClassDetail} routeTypes={['studentRoute', 'canvasStudentRoute', 'googleStudentRoute']} />
        <Route path="/student-dashboard/due-dates" component={StudentDueDates} routeTypes={['studentRoute', 'canvasStudentRoute', 'googleStudentRoute']} />
        <Route path="/student-dashboard" component={StudentDashboard} routeTypes={['studentRoute', 'canvasStudentRoute', 'googleStudentRoute']} />
        <Route
          path="/student-investigation/:investigationId/grade"
          component={InvestigationGradeReportPage}
          routeTypes={['studentRoute', 'googleStudentRoute', 'canvasStudentRoute']}
        />
        <Route
          path="/student-assessment/:assessmentId/grade"
          component={AssessmentGradeReportPage}
          routeTypes={['studentRoute']}
        />
        <Route
          path="/student-investigation/:investigationId/concept-evaluation/:stepId/:activityId/:studentId/:evaluatorId"
          component={ConceptEvaluationInvestigationPage}
          routeTypes={['studentRoute', 'teacherRoute', 'teacherAssistantRoute', 'googleStudentRoute', 'canvasStudentRoute', 'googleTeacherRoute', 'canvasTeacherRoute']}
        />
        <Route
          path="/student-investigation/:investigationId/peer-review/:stepId/:activityId/:studentId/:submissionVersion?"
          component={PeerReviewInvestigationPage}
          routeTypes={['studentRoute', 'teacherRoute', 'teacherAssistantRoute', 'googleStudentRoute', 'canvasStudentRoute', 'googleTeacherRoute', 'canvasTeacherRoute']}
        />
        <Route
          path="/student-investigation/:investigationId/peer-review-report/:stepId/:activityId/:studentId"
          component={PeerReviewReportInvestigationPage}
          routeTypes={['studentRoute', 'teacherRoute', 'teacherAssistantRoute', 'googleStudentRoute', 'canvasStudentRoute', 'googleTeacherRoute', 'canvasTeacherRoute']}
        />
        <Route
          path="/student-investigation/:investigationId/concept-evaluation/:stepId/:activityId/:studentId"
          component={ConceptEvaluationInvestigationPage}
          routeTypes={['studentRoute', 'teacherRoute', 'teacherAssistantRoute', 'googleStudentRoute', 'canvasStudentRoute', 'googleTeacherRoute', 'canvasTeacherRoute']}
        />
        <Route
          path="/student-investigation/:investigationId/concept-rating/:stepId/:activityId/:studentId"
          component={ConceptEvaluationInvestigationPage}
          routeTypes={['studentRoute', 'teacherRoute', 'teacherAssistantRoute', 'googleStudentRoute', 'canvasStudentRoute', 'googleTeacherRoute', 'canvasTeacherRoute']}
        />
        <Route
          path="/student-investigation/:investigationId/best-concept-of-group/:stepId/:activityId/:studentId"
          component={ConceptEvaluationInvestigationPage}
          routeTypes={['studentRoute', 'teacherRoute', 'teacherAssistantRoute', 'googleStudentRoute', 'canvasStudentRoute', 'googleTeacherRoute', 'canvasTeacherRoute']}
        />
        <Route
          path="/student-investigation/:investigationId/peer-review-best-concept/:stepId/:activityId/:studentId/:submissionVersion?"
          component={BestConceptPeerReviewInvestigationPage}
          routeTypes={['studentRoute', 'teacherRoute', 'teacherAssistantRoute', 'googleStudentRoute', 'canvasStudentRoute', 'googleTeacherRoute', 'canvasTeacherRoute']}
        />
        <Route
          path="/student-investigation/:investigationId/reflect-report/:stepId/:activityId/:studentId"
          component={ReflectReportInvestigationPage}
          routeTypes={['studentRoute', 'teacherRoute', 'teacherAssistantRoute', 'googleStudentRoute', 'canvasStudentRoute', 'googleTeacherRoute', 'canvasTeacherRoute']}
        />
        <Route
          path="/student-investigation/:investigationId/comments/:activityId"
          component={CommentsInvestigationPage}
          routeTypes={['studentRoute', 'teacherRoute', 'teacherAssistantRoute', 'googleStudentRoute', 'canvasStudentRoute', 'googleTeacherRoute', 'canvasTeacherRoute']}
        />
        <Route
          path="/student-investigation/:investigationId/best-concept-comments/:activityId/:submissionVersion?"
          component={BestCommentsInvestigationPage}
          routeTypes={['studentRoute', 'teacherRoute', 'teacherAssistantRoute', 'googleStudentRoute', 'canvasStudentRoute', 'googleTeacherRoute', 'canvasTeacherRoute']}
        />
        <Route
          path="/student-investigation/:investigationId/preview-file"
          component={InvestigationFilePreview}
          routeTypes={['studentRoute', 'googleStudentRoute', 'canvasStudentRoute']}
          exact
        />
        <Route path="/student-investigation/:id" component={StudentInvestigation} routeTypes={['studentRoute', 'googleStudentRoute', 'canvasStudentRoute']} exact />
        <Route path="/student-assessment/:id" component={StudentInvestigation} routeTypes={['studentRoute', 'googleStudentRoute', 'canvasStudentRoute']} exact />

        {/* Adi Admin Routes */}
        {/* <Route path="/adi-dashboard" component={AdiDashboardPage} routeTypes={['adiRoute']} exact /> */}
        <Route path="/adi-dashboard" component={AdiSuperAdminDashboard} routeTypes={['adiRoute']} exact />
        <Route path="/adi-organization-sync" component={OrganizationSyncList} routeTypes={['adiRoute']} exact />
        <Route
          path="/sync-list"
          root="Sync"
          component={SyncList}
          routeTypes={['adiRoute', 'teacherRoute', 'organizationRoute', 'googleTeacherRoute', 'canvasTeacherRoute']}
          exact
        />
        <Route
          path="/sync/:id"
          root="Sync"
          component={SyncDetailsPage}
          routeTypes={['adiRoute', 'teacherRoute', 'organizationRoute', 'googleTeacherRoute', 'canvasTeacherRoute']}
          exact
        />
        <Route path="/adi-users" component={UserList} routeTypes={['adiRoute']} exact />
        <Route path="/walkthrough" component={WalkthroughListPage} routeTypes={['adiRoute']} exact />
        <Route
          path="/walkthrough/:id"
          root="/walkthrough"
          component={WalkthroughDetailsPage}
          routeTypes={['adiRoute']}
        />
        <Route path="/adi-users/:userId" root="/adi-users" component={UserDetailsPage} routeTypes={['adiRoute']} />
        <Route
          path="/adi-organizations/:organizationId"
          root="/adi-organizations"
          component={OrganizationDetailsPage}
          routeTypes={['adiRoute']}
        />
        <Route path="/adi-organizations" component={OrganizationList} routeTypes={['adiRoute']} />
        <Route
          path="/adi-assessments/templates"
          root="/adi-assessments"
          component={AdiAssessmentTemplatesPage}
          routeTypes={['adiRoute']}
        />
        <Route
          path="/adi-assessments/assessments-list"
          root="/adi-assessments"
          component={AdiAssessmentListPage}
          routeTypes={['adiRoute']}
        />
        <Route
          path="/adi-assessments/investigation-list"
          component={AdiInvestigationListPage}
          root="/adi-assessments"
          routeTypes={['adiRoute']}
        />
        <Route
          path="/adi-assessments/edit/:investigationId/core"
          root="/adi-assessments"
          component={AdiEditInvestigationCorePage}
          routeTypes={['adiRoute']}
        />
        <Route
          path="/adi-assessments/edit/:investigationId/settings/:stageId/parts"
          root="/adi-assessments"
          component={AdiEditInvestigationActivitiesPage}
          routeTypes={['adiRoute']}
        />
        <Route
          path="/adi-assessments/edit/:investigationId/settings"
          root="/adi-assessments"
          component={AdiEditInvestigationStagesPage}
          routeTypes={['adiRoute']}
        />
        <Route path="/adi-assessments" component={AdiAssessmentPage} routeTypes={['adiRoute']} />
        <Route
          path="/adi-investigations/templates"
          component={AdiTemplatesPage}
          root="/adi-investigations"
          routeTypes={['adiRoute', 'organizationRoute', 'writerRoute']}
        />
        <Route
          path="/adi-investigations/investigation-list"
          component={AdiInvestigationListPage}
          root="/adi-investigations"
          routeTypes={['adiRoute', 'organizationRoute', 'writerRoute']}
        />
        <Route
          path="/adi-investigations/edit/:investigationId/core"
          root="/adi-investigations"
          component={AdiEditInvestigationCorePage}
          routeTypes={['adiRoute', 'organizationRoute', 'writerRoute']}
        />
        <Route
          path="/adi-investigations/edit/:investigationId/preview"
          root="/adi-investigations"
          component={AdiEditInvestigationPreviewPage}
          routeTypes={['adiRoute', 'organizationRoute', 'writerRoute']}
        />
        <Route
          path="/adi-investigations/edit/:investigationId/stages/:stageId/activities"
          root="/adi-investigations"
          component={AdiEditInvestigationActivitiesPage}
          routeTypes={['adiRoute', 'organizationRoute', 'writerRoute']}
        />
        <Route
          path="/adi-investigations/edit/:investigationId/stages"
          root="/adi-investigations"
          component={AdiEditInvestigationStagesPage}
          routeTypes={['adiRoute', 'organizationRoute', 'writerRoute']}
        />
        <Route path="/adi-investigations" component={AdiInvestigationsPage} routeTypes={['adiRoute']} />
        <Route path="/adi-workshop-investigations" component={AdiInvestigationsPage} routeTypes={['adiRoute']} />

        {/* Organization Admin Routes */}
        <Route path="/organization-dashboard" component={AdiDashboardPage} routeTypes={['organizationRoute']} exact />
        <Route path="/organization-kpi" component={AdiDashboardPage} routeTypes={['organizationRoute']} exact />
        <Route path="/organization-users" component={UserList} routeTypes={['organizationRoute']} exact />
        <Route
          path="/organization-details"
          component={OrganizationDetailsPage}
          routeTypes={['organizationRoute']}
          exact
        />
        <Route path="/organization/user/:userId" component={UserDetailsPage} routeTypes={['organizationRoute']} exact />
        <Route
          path="/organization-library"
          component={AdiInvestigationsPage}
          routeTypes={['organizationRoute', 'writerRoute']}
        />
        <Route
          path="/investigation-presentation/:investigationId"
          component={InvestigationPresentationPage}
          routeTypes={['organizationRoute', 'writerRoute', 'teacherRoute', 'canvasTeacherRoute', 'googleTeacherRoute', 'bookRoute']}
        />

        <Route
          path="/googleclassroom-teacher-dashboard/:courseName/:courseId/assignment-summary/:courseWorkId"
          component={GoogleTeacherAssignmentSummary}
          routeTypes={['googleTeacherRoute']}
        />
        <Route
          path="/googleclassroom-teacher-dashboard/class/:courseId/assignment-summary"
          component={GoogleAssignmentSummaryDasboard}
          routeTypes={['googleTeacherRoute']}
        />
        <Route
          path="/googleclassroom-teacher-dashboard/class/:courseId/create-assignment"
          component={GoogleAssignmentCorePage}
          routeTypes={['googleTeacherRoute']}
        />
        <Route
          path="/googleclassroom-teacher-dashboard/class/:id"
          component={GoogleClassDashboard}
          routeTypes={['googleTeacherRoute']}
        />
        <Route
          path="/googleclassroom-teacher-dashboard"
          component={GoogleClassroomTeachersDashboardPage}
          routeTypes={['googleTeacherRoute']}
        />
        {/* //TODO: Need to remove google student route */}
        <Route
          path="/googleclassroom-students-assignmentduedate"
          component={GoogleStudentsAssignmentDueDate}
          routeTypes={['googleStudentRoute']}
        />
        {/* //TODO: Useless route @sufian */}
        <Route
          path="/googleclassroom-students-dashboard/class/:courseId/:courseWorkId/:Id"
          component={AssignmentSummaryPopup}
          routeTypes={['googleStudentRoute']}
        />
        <Route
          path="/googleclassroom-students-dashboard/class/:id"
          component={GoogleStudentsClassDashboard}
          routeTypes={['googleStudentRoute']}
        />
        <Route
          path="/googleclassroom-students-dashboard"
          component={GoogleClassroomStudentsDashboardPage}
          routeTypes={['googleStudentRoute']}
        />
        {/* //TODO: Need to remove google student route  above*/}
        <Route
          path="/googleclassroom-teacher-assignment/class/:courseId/edit-assignment/:courseWorkId"
          component={GoogleAssignmentCorePage}
          routeTypes={['googleTeacherRoute']}
        />
        <Route
          path="/googleclassroom-teacher-assignment"
          component={GoogleClassroomTeacherAssignmentPage}
          routeTypes={['googleTeacherRoute']}
        />
        <Route
          path="/canvas-teacher-dashboard/class/:courseId/assignment-summary/:assignmentId"
          component={CanvasTeacherAssignmentSummary}
          routeTypes={['canvasTeacherRoute']}
        />
        <Route
          path="/canvas-teacher-dashboard/class/:courseId/create-assignment"
          component={CanvasAssignmentCorePage}
          routeTypes={['canvasTeacherRoute']}
        />
        <Route
          path="/canvas-teacher-dashboard/class/:courseId"
          component={CanvasTeachersClassDashboard}
          routeTypes={['canvasTeacherRoute']}
        />
        <Route
          path="/canvas-teacher-dashboard"
          component={CanvasTeachersDashboard}
          routeTypes={['canvasTeacherRoute']}
        />
        {/* //TODO: Need to remove canvas student route */}
        <Route
          path="/canvas-students-dashboard/class/:courseId"
          component={CanvasStudentsClassDashboard}
          routeTypes={['canvasStudentRoute']}
        />
        <Route
          path="/canvas-students-dashboard"
          component={CanvasStudentsDashboardPage}
          routeTypes={['canvasStudentRoute']}
        />
        <Route
          path="/canvas-students-assignmentduedate"
          component={CanvasStudentsAssignmentDuedate}
          routeTypes={['canvasStudentRoute']}
        />
        {/* //TODO: Need to remove canvas student route above*/}
        <Route
          path="/canvas-teacher-assignment/class/:courseId/edit-assignment/:assignmentId"
          component={CanvasAssignmentCorePage}
          routeTypes={['canvasTeacherRoute']}
        />
        <Route
          path="/canvas-teacher-assignment"
          component={CanvasTeacherAssignmentPage}
          routeTypes={['canvasTeacherRoute']}
        />

        <Route path="/" component={LoginNew} routeTypes={['onlyUnauthenticatedRoute']} />
      </Switch>
    </App>
  );
};
